const indexItems = [
  {
    title: '明星恋情合集',
    desc: '顶流恋爱、地下情曝光、分手实锤，娱乐圈感情纠葛全收录',
    count: 128,
    icon: 'ri-heart-pulse-line',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    title: '综艺翻车合集',
    desc: '录制事故、嘉宾互撕、剧本争议，综艺节目名场面大汇总',
    count: 96,
    icon: 'ri-emotion-sad-line',
    color: 'bg-accent-100 text-accent-700',
  },
  {
    title: '网红黑料合集',
    desc: '带货翻车、人设崩塌、数据造假，网红圈那些不为人知的事',
    count: 215,
    icon: 'ri-user-unfollow-line',
    color: 'bg-secondary-100 text-secondary-700',
  },
  {
    title: '影视圈内幕',
    desc: '选角潜规则、片酬争议、剧组纠纷，揭开影视行业神秘面纱',
    count: 87,
    icon: 'ri-film-line',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    title: '音乐圈八卦',
    desc: '抄袭风波、假唱实锤、版权大战，音乐圈纷纷扰扰一网打尽',
    count: 73,
    icon: 'ri-music-line',
    color: 'bg-accent-100 text-accent-700',
  },
  {
    title: '时尚圈爆料',
    desc: '品牌代言争夺、红毯翻车、设计师内斗，时尚圈暗流涌动',
    count: 54,
    icon: 'ri-t-shirt-line',
    color: 'bg-secondary-100 text-secondary-700',
  },
  {
    title: '直播界大瓜',
    desc: '头部主播纠纷、公会内幕、平台博弈，直播圈的精彩不输综艺',
    count: 162,
    icon: 'ri-live-line',
    color: 'bg-primary-100 text-primary-600',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 md:h-7 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">爆料合集</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-300/60 transition-all duration-300 cursor-pointer group"
            >
              <div className={`w-10 h-10 rounded-lg ${item.color} flex items-center justify-center mb-3 group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                {item.desc}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-400">{item.count} 条爆料</span>
                <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-500 group-hover:translate-x-1 transition-all text-sm"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}